export const TEMPLATE_PICKER_OPEN_EVENT_TYPES = {
    ICON_CLICK: 'iconClick',
    INPUT_CHANGE: 'inputChange',
    INPUT_FOCUS: 'inputFocus',
} as const;

export type TemplatePickerOpenEvent =
    | { type: typeof TEMPLATE_PICKER_OPEN_EVENT_TYPES.ICON_CLICK }
    | { type: typeof TEMPLATE_PICKER_OPEN_EVENT_TYPES.INPUT_FOCUS; inputEmpty: boolean }
    | { type: typeof TEMPLATE_PICKER_OPEN_EVENT_TYPES.INPUT_CHANGE; hasContent: boolean };

/** Next `manualOverlayOpen` only. Forced empty/expired overlay ignores this. */
export function resolveTemplatePickerOpenChange(overlayOpen: boolean, event: TemplatePickerOpenEvent): boolean {
    switch (event.type) {
        case TEMPLATE_PICKER_OPEN_EVENT_TYPES.ICON_CLICK:
            return !overlayOpen;
        case TEMPLATE_PICKER_OPEN_EVENT_TYPES.INPUT_FOCUS:
            return event.inputEmpty ? true : overlayOpen;
        case TEMPLATE_PICKER_OPEN_EVENT_TYPES.INPUT_CHANGE:
            return event.hasContent ? false : overlayOpen;
        default:
            return ((_exhaustive: never) => overlayOpen)(event);
    }
}
